import "../../Styles/General & MultiUse/Loader.css";
import { ColorRing } from "react-loader-spinner";
import ReactDOM from "react-dom";
import { ZGAContext } from "../../ZGAContext";
import { useContext, useEffect } from "react";

const Loader = () => {
  const { isSubmitting, setIsSubmitting } = useContext(ZGAContext);

  useEffect(() => {
    const handlePopState = () => {
      if (isSubmitting) {
        setIsSubmitting(false);
      }
    };
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [isSubmitting, setIsSubmitting]);

  if (!isSubmitting) return null;

  return ReactDOM.createPortal(
    <>
      <div className="backdrop"></div>
      <div className="loader">
        <ColorRing
          visible={true}
          height="100"
          width="100"
          ariaLabel="color-ring-loading"
          wrapperStyle={{}}
          wrapperClass="color-ring-wrapper"
          colors={["#391642", "#d9d9d94d", "#391642", "#dda3cd", "#391642"]}
        />
      </div>
    </>,
    document.getElementById("modal-root")
  );
};

export default Loader;
